import React from 'react';
import { BellIcon, UserIcon, LogOutIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  return <nav className="bg-white border-b border-gray-200 px-4 py-2.5 flex justify-between items-center" data-id="element-37">
      <div className="flex items-center lg:hidden" data-id="element-38">
        <button className="p-2 rounded-md hover:bg-gray-100" data-id="element-39">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-40">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-41" />
          </svg>
        </button>
      </div>
      <div className="flex-1 flex justify-end items-center space-x-4" data-id="element-42">
        <div className="relative" data-id="element-43">
          <button className="p-2 rounded-full hover:bg-gray-100 relative" data-id="element-44">
            <BellIcon className="w-6 h-6 text-gray-600" data-id="element-45" />
            <span className="absolute top-1 right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white" data-id="element-46"></span>
          </button>
        </div>
        <div className="flex items-center" data-id="element-47">
          <div className="hidden md:flex flex-col items-end mr-3" data-id="element-48">
            <span className="text-sm font-medium" data-id="element-49">Acme Supplies</span>
            <span className="text-xs text-gray-500" data-id="element-50">Supplier</span>
          </div>
          <div className="relative" data-id="element-51">
            <button className="flex items-center focus:outline-none" data-id="element-52">
              <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-53">
                <UserIcon className="w-5 h-5 text-gray-600" data-id="element-54" />
              </div>
            </button>
            {/* Dropdown menu would go here */}
          </div>
        </div>
      </div>
    </nav>;
};
export default Navbar;